import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <span className="inline-flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-2xl text-primary-600">
        <i className="ri-fire-line"></i>
      </span>
      <p className="mt-6 font-heading text-6xl font-black text-primary-500">404</p>
      <h1 className="mt-3 font-heading text-xl font-bold text-foreground-950">
        这一页爆掉的瓜，不存在
      </h1>
      <p className="mt-2 max-w-md text-sm text-foreground-600">
        你访问的页面可能已被下线或链接失效。回到首页，看看最新的圈内热瓜吧。
      </p>
      <Link
        to="/"
        className="c-btn mt-6 bg-primary-500 text-background-50 hover:bg-primary-600"
      >
        <i className="ri-arrow-left-line mr-1.5"></i>
        返回首页
      </Link>
    </div>
  );
}